import "./header.css";
import React, { useState } from "react";

import BrandLogo from '../../assets/elyas_logo.png'

export default function Header(){
    /* ========== Change background header ========== */
    window.addEventListener("scroll", function(){
        const header = document.querySelector(".header");
        if(window.scrollY >= 200){
            header.classList.add("scroll-header");
        }else{
            header.classList.remove("scroll-header");
        }
    });
    /* ========== Toggle Menu ========== */
    const [Toggle, showMenu] = useState(false);
    const [activeNav, setActiveNav] = useState("#home");

    return (
        <div className="header">
           <nav className="nav container">
                <a href="#home" className="nav__logo">
                    <img className="nav__logo_img" src={BrandLogo} alt="elyas afghan brand" />
                </a>
                <div className={Toggle ? " nav__menu show-menu" : "nav__menu"}>
                    <ul className="flex nav__list">
                        
                        {/* <li className="nav__item">
                            <a href="#home" onClick={() => setActiveNav ('#home')} className={activeNav === "#home" ? "nav__link active-link" : "nav__link"}>
                                <i className="uil uil-estate nav__icon"></i> Home
                            </a>
                        </li> */}

                        <li className="nav__item">
                            <a href="#about" onClick={() => setActiveNav ('#about')} className={activeNav === "#about" ? "nav__link active-link" : "nav__link"} >
                                <i className="uil uil-user nav__icon"></i> About
                            </a>
                        </li>

                        {/* <li className="nav__item">
                            <a href="#skills" onClick={() => setActiveNav ('#skills')} className={activeNav === "#skills" ? "nav__link active-link" : "nav__link"} >
                                <i className="uil uil-file-alt nav__icon"></i> Skills
                            </a>
                        </li> */}

                        {/* <li className="nav__item">
                            <a href="#services" onClick={() => setActiveNav ('#services')} className={activeNav === "#services" ? "nav__link active-link" : "nav__link"} >
                                <i className="uil uil-briefcase-alt nav__icon"></i> Services
                            </a>
                        </li> */}

                        <li className="nav__item">
                            <a href="#portfolio" onClick={() => setActiveNav ('#portfolio')} className={activeNav === "#portfolio" ? "nav__link active-link" : "nav__link"} >
                            <i class="uil uil-file-shield-alt nav__icon"></i> Project
                            </a>
                        </li>

                        <li className="nav__item">
                            <a href="#contact" onClick={() => setActiveNav ('#contact')} className={activeNav === "#contact" ? "nav__link active-link" : "nav__link"} >
                                <i className="uil uil-message nav__icon"></i> Contact
                            </a>
                        </li>

                    </ul>
                    <i className="uil uil-times nav__close" onClick={() => showMenu(!Toggle)} id="nav-close"></i>
                </div>
                
                <div className="nav__toggle" onClick={() => showMenu(!Toggle)}>
                    <i className="uil uil-apps" id="nav-toggle"></i>
                </div>
           </nav>
        </div>
    );
};
